/*
 * Wishlist Empty State Handler
 * This script modifies the Swishlist app's empty state to match theme requirements.
 */
(() => {
  const SELECTORS = {
    emptyDetails: '.st-wishlist-details_empty',
    footerButtons: '.st-is-empty.st-wishlist-details.st-wishlist-details--drawer .st-wishlist-details_footer_buttons'
  };

  const updateWishlistEmptyState = () => {
    // 1. Update empty message
    const emptyDetails = document.querySelector(SELECTORS.emptyDetails);
    if (emptyDetails && !emptyDetails.dataset.customized) {
      emptyDetails.innerHTML = '';
      const p = document.createElement('p');
      p.textContent = 'your wishlist is currently empty';
      emptyDetails.appendChild(p);
      emptyDetails.dataset.customized = 'true';
    }

    // 2. Add Continue Shopping button
    const footerButtons = document.querySelector(SELECTORS.footerButtons);
    if (footerButtons) {
      if (!footerButtons.querySelector('.continue-shopping-btn')) {
        const btn = document.createElement('a');
        btn.href = '/collections/all';
        btn.textContent = 'Continue Shopping';
        // Using 'button button--primary' as seen in theme snippets
        btn.className = 'button button-primary continue-shopping-btn';
        footerButtons.appendChild(btn);
      }
    }

    // 3. Apply color scheme to the drawer
    const wishlistDrawerWrapper = document.querySelector('.st-wishlist-details_wrapper');
    const colorScheme = typeof Theme !== 'undefined' ? Theme?.settings?.wishlist_drawer_color_scheme : null;
    if (wishlistDrawerWrapper && colorScheme && !wishlistDrawerWrapper.classList.contains(`color-${colorScheme}`)) {
      wishlistDrawerWrapper.classList.add(`color-${colorScheme}`);
    }
  };

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistEmptyState);
  } else {
    updateWishlistEmptyState();
  }

  // Use MutationObserver because the wishlist app loads content dynamically
  const observer = new MutationObserver((mutations) => {
    updateWishlistEmptyState();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
